// extracted by css-extract-rspack-plugin
export default {"text":"_43180c17","linkText":"_d09c4977","arrow":"_61aa1c93"};